<template>
  <!-- App.vue -->
  <v-app>
    <v-navigation-drawer v-model="drawer" app clipped-left temporary>
      <v-list-item link to="/">
        <v-list-item-avatar>
          <v-img src="@/assets/ObiPetsLogo.svg"></v-img>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>ObiPets</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-item link to="AdminDash">
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Inicio</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link>
          <v-list-item-icon>
            <v-icon>mdi-qrcode-plus</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title @click.stop="dialog = !dialog">
              Generar Codigos
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- <v-list-item link to="/dashboard/veterinarias">
          <v-list-item-icon>
            <v-icon>mdi-store</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title> Agregar Vetinarias </v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
      </v-list>

      <template>
        <div>
          <v-btn block @click="_logout"> Cerrar sesión </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
    <!-- Sizes your content based upon application components -->
    <v-content class="maindash">
      <!-- Provides the application the proper gutter -->
      <v-container fluid>
        <div class="text-center mb-8">
          <v-btn @click.stop="drawer = !drawer">
            <v-icon>{{ "mdi-menu" }}</v-icon>
          </v-btn>
        </div>
        <v-row>
          <v-col cols="12" align-self="center">
            <v-row justify="center">
              <v-col cols="6">
                <v-row justify="center">
                  <v-select
                    placeholder="Año"
                    v-model="per_year"
                    :items="years"
                    @change="filterByYear()"
                  ></v-select>
                  <v-select
                    placeholder="Mes"
                    v-model="per_month"
                    :items="months"
                    @change="filterByMonth()"
                  ></v-select>
                </v-row>
              </v-col>
            </v-row>

            <v-data-table
              :headers="file_headers"
              :items="documents"
              class="elevation-1"
              :footer-props="{
                showFirstLastPage: false,
                itemsPerPageOptions: [5],
              }"
            >
              <template v-slot:body="{ items }">
                <tbody v-for="item in items" :key="item.id">
                  <tr class="main-table">
                    <td>{{ item.id }}</td>
                    <td>{{ item.filename }}</td>
                    <td>{{ item.quantity }}</td>
                    <td>{{ item.createdAt }}</td>
                    <td>
                      <v-btn :href="item.file" target="_blank">
                        <v-icon>{{ "mdi-file-pdf-outline" }}</v-icon>
                      </v-btn>
                    </td>
                    <td>
                      <v-btn
                        v-if="actualId != item.id"
                        @click="data4excel(item.id)"
                      >
                        Generar <v-icon>{{ "mdi-microsoft-excel" }}</v-icon>
                      </v-btn>
                      <downloadExcel
                        v-else-if="actualId == item.id"
                        class="btn"
                        type="xls"
                        :data="dataForExcel"
                        :name="'PetsCode_' + item.createdAt + '.xls'"
                      >
                        <v-btn>
                          Obtener <v-icon>{{ "mdi-microsoft-excel" }}</v-icon>
                        </v-btn>
                      </downloadExcel>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
            <v-btn
              v-if="per_year !== '' || per_month !== ''"
              @click="getPetsCodeFiles"
            >
              Ver todos
            </v-btn>
          </v-col>
          <!-- <v-col>
            <v-data-table
              :headers="veterinary_headers"
              :items="veterinarys"
              class="elevation-1"
              :footer-props="{
                showFirstLastPage: false,
                itemsPerPageOptions: [5],
              }"
            >
             <template v-slot:body="{ items }">
            <tbody v-for="item in items" :key="item.id">
              <tr class="main-table">
                <td>{{ item.id}}</td>
                <td>{{ item.storeName}}</td>
                <td>{{ item.phoneNumber}}</td>
                <td>{{ item.addrress}}</td>
                <td>
                  <v-btn
                    icon
                    color="yellow"
                    small
                   @click.prevent="editStore(item.id)"
                  >
                    <v-icon>{{'mdi-pencil'}}</v-icon>
                  </v-btn>
                </td>
                <td>
                  <v-btn
                    icon
                    color="red"
                    small
                   
                  >
                    <v-icon>{{'mdi-trash-can'}}</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
             </template>
            </v-data-table>
          </v-col> -->
        </v-row>

        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <v-container>
              <v-row align="center" justify="center">
                <v-col>
                  <v-form>
                    <form-wrapper :validator="$v.form">
                      <div style="margin-bottom: 20px">
                        <form-summary />
                      </div>
                      <form-group name="numcode">
                        <template slot-scope="{ attrs }">
                          <v-text-field
                            outlined
                            v-bind="attrs"
                            v-model="form.numcode"
                            append-icon="mdi-qrcode-plus"
                            label="Numero de codigos"
                            @input="$v.form.numcode.$touch()"
                          />
                        </template>
                      </form-group>
                    </form-wrapper>
                  </v-form>
                </v-col>
                <v-card-text>
                  <p>No mas de 100 códigos por archivo</p>
                </v-card-text>
                <v-card-actions>
                  <v-btn :disabled="$v.$invalid" @click.prevent="createCodes">
                    Crear
                    <v-icon> mdi-qrcode-plus </v-icon>
                  </v-btn>
                  <v-btn @click.stop="dialog = !dialog"> Cancelar </v-btn>
                </v-card-actions>
              </v-row>
            </v-container>
          </v-card>
        </v-dialog>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
import { between, numeric, required } from "vuelidate/lib/validators";
import { mapActions } from "vuex";
export default {
  created() {
    this.getPetsCodeFiles();
    this.getStoresMet();
  },
  data() {
    return {
      per_year: "",
      per_month: "",
      months: [],
      years: [],
      page: 1,
      created: "",
      actualId: "",
      dataForExcel: [],
      veterinarys:[],
      dialog: false,
      form: {
        numcode: "",
      },
      documents: [],
      drawer: null,
      file_headers: [
        { text: "ID", value: "id", align: "center" },
        { text: "Archivo", value: "filename", align: "center" },
        { text: "Cantidad", value: "quantity", align: "center" },
        { text: "Creación", value: "createdAt", align: "center" },
        { text: "PDF", value: "file", align: "center" },
        { text: "Excel", value: "", align: "center" },
      ],
      veterinary_headers: [
        { text: "ID", value: "id", align: "center" },
        { text: "Veterinaria", value: "storeName", align: "center" },
        { text: "Telefono", value: "phoneNumber", align: "center" },
        { text: "Direccion", value: "addrress", align: "center" },
      ],
    };
  },
  validations: {
    form: {
      numcode: {
        required,
        numeric,
        between: between(1, 100),
      },
    },
  },
  methods: {
    ...mapActions("auth", { logout: "logout" }),
    ...mapActions("admin", {
      createCode: "createCode",
      getStores: "getStores",
      getPetsCode: "getPetsCode",
      getData4excel: "getData4excel",
    }),
    editStore(id){
      this.$router.push({ name: "modVet", params: { id } });
    },
    getStoresMet() {
      this.getStores().then((res) => {
        this.veterinarys = res;
      });
    },
    createCodes() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        console.error("Revise datos");
      } else {
        let codes = {
          quantityCodes: this.form.numcode,
        };
        this.dialog = false;
        this.createCode(codes)
          .then((data) => {
            this.getPetsCodeFiles();
            window.open(
              "https://www.obipets.com.mx" + data.data.file,
              "_blank"
            );
            this.form.numcode = "";
          })
          .catch(() => {});
      }
    },
    getPetsCodeFiles() {
      this.per_year = "";
      this.per_month = "";
      this.getPetsCode().then((res) => {
        this.documents = res.results;
        for (let key in res.results) {
          let year = res.results[key].createdAt;
          let monthsearch = res.results[key].createdAt;
          this.years.push(year.substr(0, 4));
          let month = monthsearch.substr(5, 5);
          this.months.push(month.substr(0, 2));
        }
      });
    },
    async data4excel(document_id) {
      this.dataForExcel = [];
      this.getData4excel()
        .then((res) => {
          for (let key in res.results) {
            if (document_id == res.results[key].petCodeFileId) {
              this.actualId = res.results[key].petCodeFileId;
              this.dataForExcel.push({
                Id_Code: res.results[key].id,
                Code_Activation: res.results[key].codeActivation,
                Id_File_Code: res.results[key].petCodeFileId,
                URL: res.results[key].url,
              });
            }
          }
          this.created = document_id;
        })
        .catch((err) => {
          this.snackbar = true;
          this.scanCode = false;
          this.formActivate = true;
          this.form.codeActivate = "";
          if (err.response) {
            this.snackbarText = err.response.data;
          } else {
            this.snackbarText = err;
          }
        });
    },
    filterByYear() {
      this.getPetsCode().then((res) => {
        this.documents = [];
        for (let key in res.results) {
          let year = res.results[key].createdAt;
          if (this.per_year == year.substr(0, 4)) {
            this.documents.push(res.results[key]);
          }
        }
      });
    },
    filterByMonth() {
      if (this.per_year !== "" && this.per_month !== "") {
        var yearpulsmonth = this.per_year + "-" + this.per_month;
        this.getPetsCode().then((res) => {
          this.documents = [];
          for (let key in res.results) {
            let year = res.results[key].createdAt;
            if (yearpulsmonth == year.substr(0, 7)) {
              this.documents.push(res.results[key]);
            }
          }
        });
      } else if (this.per_month !== "") {
        this.getPetsCode().then((res) => {
          this.documents = [];
          for (let key in res.results) {
            let monthsearch = res.results[key].createdAt;
            let month = monthsearch.substr(5, 5);
            if (this.per_month === month.substr(0, 2)) {
              this.documents.push(res.results[key]);
            }
          }
        });
      }
    },
    _logout() {
      this.logout();
      this.$router
        .push({
          name: "login",
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.v-data-table {
  .v-data-footer {
    .v-data-footer__select {
      display: none;
    }
  }
}
.main-table td {
  text-align: center;
}
.maindash {
  background-image: url("../../assets/img/backgrounds/fondoblanco.png");
  background-size: cover;
}
</style>
